'use strict';

require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
require("moduleFold/validatori/scripts/index.js");
var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");


/**
 * Campo di tipo entity su entity esterna
 * 
 * @class  
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {Valida} Valida
 */
function BSSLocalita(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bsslocalita', 
        //extends: 'bssselect',
        template: require("./bsslocalita.html"), //"src/bsslib/formbuilder/scripts/campi/localita/bsslocalita.html",
        controller: ["$scope", "$filter", "$timeout", "$http", "$sce", "ErrorManager", "DSFactory", "FieldFactory", "Valida", require("./BssLocalitaController")],
        defaultOptions: {
            ngModelElAttrs: {
                'cssCategory': 'bsslocalita'
            },
        }
    }));
}

module.exports = BSSLocalita;